import { GridAlignment } from '../enums';

export interface GridStackedHeaderColumn {
  columnDef: string;
  headerText?: string;
  customHeaderClass?: string;
  colspan?: number;
  alignment?: GridAlignment;
}
